var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAddSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44531 7.25012C2.44531 4.67213 2.44531 3.38313 3.24619 2.58225C4.04707 1.78137 5.33607 1.78137 7.91406 1.78137C10.492 1.78137 11.7811 1.78137 12.5819 2.58225C13.3828 3.38313 13.3828 4.67213 13.3828 7.25012C13.3828 9.82809 13.3828 11.1171 12.5819 11.918C11.7811 12.7189 10.492 12.7189 7.91406 12.7189C5.33607 12.7189 4.04707 12.7189 3.24619 11.918C2.44531 11.1171 2.44531 9.82809 2.44531 7.25012Z",
    stroke: "#313131",
    strokeWidth: 0.875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55469 7.25012H7.91406M7.91406 7.25012H6.27344M7.91406 7.25012V5.6095M7.91406 7.25012V8.89075",
    stroke: "#313131",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddSquare);
export default __webpack_public_path__ + "static/media/icon-add-square.d25078a451a5130bede4d4442dc64caa.svg";
export { ForwardRef as ReactComponent };